import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, SmartphoneIcon } from 'lucide-react';
import { bonuses } from '../data/volumes';
export function Bonuses() {
  return <section aria-label="Bonuslar" className="border-y border-grape/10 bg-white/70" data-id="element-16" data-mp="av34oprykyzk">
      <div className="mx-auto max-w-5xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "22px"
    }} data-id="element-17" data-mp="at8vu9tyoxbu">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-18" data-mp="1un4bp6ii7yx">
          🎁 4 Ücretsiz Bonus
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-sm font-bold uppercase tracking-wide text-blush" data-id="element-19" data-mp="5wrx6lp4z0ki">
          Bugünkü teklif kapsamında
        </p>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-20" data-mp="3t0g6egxh6gen">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative flex gap-4 rounded-2xl border border-grape/20 bg-cream p-6" style={{
          paddingTop: "16px",
          paddingBottom: "16px"
        }} data-id="element-21" data-mp="3t2j4lo8s7fug" data-mpi={i}>
              <img src={b.cover} alt={`${b.title} bonus kapağı`} width={1122} height={1402} loading="lazy" decoding="async" sizes="112px" className="h-auto w-24 shrink-0 self-start object-contain drop-shadow-[0_10px_18px_rgba(11,18,32,0.35)] sm:w-28" data-id="element-22" data-mp="3n54y8gyh6zyx" />
              <div className="flex min-w-0 flex-col" data-id="element-23" data-mp="2uhsl0xe7g4ia">
                <div className="mb-3 flex flex-wrap items-center justify-between gap-2" data-id="element-24" data-mp="38g0id6f5l7tz">
                  <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-lilac-soft px-3 py-1 text-xs font-bold text-grape" data-id="element-25" data-mp="33h5o98bqjwuk">
                    <GiftIcon className="h-3.5 w-3.5" data-id="element-26" data-mp="nogfh67vtdsz" /> Bonus {b.n}
                  </span>
                  <span className="whitespace-nowrap text-sm font-bold" data-id="element-27" data-mp="iq57l115ddde">
                    
                    <span className="text-plum/40 line-through" data-id="element-28" data-mp="3ci4ufbjolfra">{b.price}</span>{' '}
                    <span className="text-blush" data-id="element-29" data-mp="3hh8110fb7u1d">ÜCRETSİZ</span>
                  </span>
                </div>
                <h3 className="text-base font-bold text-plum" data-id="element-30" data-mp="3lknx9vngvsdj">{b.title}</h3>
                <p className="mt-0.5 text-xs font-semibold text-grape" data-id="element-31" data-mp="3qj7i1sqbqy4b">{b.subtitle}</p>
                <p className="mt-2 text-sm leading-relaxed text-plum/65" data-id="element-32" data-mp="2tsoscjsclf8r">{b.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <p className="mt-8 flex items-center justify-center gap-2 text-center text-sm font-semibold text-plum/60" data-id="element-33" data-mp="2xutmdjmpkdvx">
          <SmartphoneIcon className="h-4 w-4 shrink-0 text-grape" aria-hidden="true" data-id="element-34" data-mp="32rsc7pzc9yob" />
          Dijital materyallerinize telefonunuzdan veya uyumlu bir bilgisayardan erişin.
        </p>

        <div className="mt-6 rounded-2xl border border-blush/30 bg-blush-soft p-6 text-center" style={{
        paddingTop: "11px",
        paddingBottom: "11px"
      }} data-id="element-35" data-mp="2a3wj0v8zaowa">
          <p className="text-base font-bold text-plum sm:text-lg" data-id="element-36" data-mp="27k9o1es1echm">
            💰 Toplam bonus değeri: <span className="text-plum/50 line-through" data-id="element-37" data-mp="22keybejzzsy5">5.925 TRY</span>{' '}
            <span className="text-[15px] text-blush-deep" data-id="element-38" data-mp="1xlts8yi2ef1s">
              Ana ürünle birlikte ÜCRETSİZ
            </span>
          </p>
        </div>
      </div>
    </section>;
}